export const fish = [
  {
    id: "91",
    name: "Agrias Butterfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/d/dc/NH-Icon-agriasbutterfly.png/revision/latest?cb=20200401005428",
    location: "Flying",
    type: "bug",
    value: "3000",
    time: "8AM - 5PM",
  },
  {
    id: "57",
    name: "Anchovy",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/24/NH-Icon-anchovy.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "200",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "4 a.m. - 9 p.m.",
    shadow: "Small",
  },
  {
    id: "3",
    name: "Angelfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/63/NH-Icon-angelfish.png/revision/latest?cb=20200401003128",
    location: "River",
    type: "fish",
    value: "3000",
    months: "[May, June, July, August, September, October]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Small",
  },
  {
    id: "150",
    name: "Ant",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/4/45/NH-Icon-ant.png/revision/latest?cb=20200401005428",
    location: "On rotten turnips and fruit",
    type: "bug",
    value: "80",
    time: "All day",
  },
  {
    id: "20",
    name: "Arapaima",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7f/NH-Icon-arapaima.png/revision/latest?cb=20200401003128",
    location: "River",
    type: "fish",
    value: "10000",
    months: "[June, July, August, September]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Largest",
  },
  {
    id: "56",
    name: "Arowana",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/b/bf/NH-Icon-arowana.png/revision/latest?cb=20200401003128",
    location: "River",
    type: "fish",
    value: "10000",
    months: "[June, July, August, September]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Large",
  },
  {
    id: "95",
    name: "Atlas moth",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/6a/NH-Icon-atlasmoth.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "3000",
    time: "7PM - 4AM",
  },
  {
    id: "149",
    name: "Bagworm",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/81/NH-Icon-bagworm.png/revision/latest?cb=20200401005428",
    location: "Falls from trees when shaking them",
    type: "bug",
    value: "600",
    time: "All day",
  },
  {
    id: "115",
    name: "Banded dragonfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/64/NH-Icon-bandeddragonfly.png/revision/latest?cb=20200401005428",
    location: "Flying",
    type: "bug",
    value: "4500",
    time: "8AM - 5PM",
  },
  {
    id: "11",
    name: "Barred Knifejaw",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/8c/NH-Icon-barredknifejaw.png/revision/latest?cb=20200401003128",
    location: "Sea",
    type: "fish",
    value: "5000",
    months:
      "[March, April, May, June, July, August, September, October, November]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "15",
    name: "Barreleye",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c7/NH-Icon-barreleye.png/revision/latest?cb=20200401003128",
    location: "Sea",
    type: "fish",
    value: "15000",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "9 p.m. - 4 a.m.",
    shadow: "Small",
  },
  {
    id: "102",
    name: "Bell cricket",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/99/NH-Icon-bellcricket.png/revision/latest?cb=20200401005428",
    location: "In Grass",
    type: "bug",
    value: "430",
    time: "5PM - 8AM",
  },
  {
    id: "2",
    name: "Betta",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7c/NH-Icon-betta.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "2500",
    months: "[May, June, July, August, September, October]",
    time: "5 p.m. - 9 a.m.",
    shadow: "Small",
  },
  {
    id: "4",
    name: "Bitterling",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/ea/NH-Icon-bitterling.png/revision/latest?cb=20200401003128",
    location: "River",
    type: "fish",
    value: "900",
    months: "[January, February, March, November, December]",
    time: "All day",
    shadow: "Smallest",
  },
  {
    id: "55",
    name: "Black Bass",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/e2/NH-Icon-blackbass.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "400",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "Large",
  },
  {
    id: "5",
    name: "Blowfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/3/39/NH-Icon-blowfish.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "5000",
    months: "[January, February, November, December]",
    time: "6 p.m. - 4 a.m.",
    shadow: "Medium",
  },
  {
    id: "61",
    name: "Blue Marlin",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/2f/NH-Icon-bluemarlin.png/revision/latest?cb=20200401003129",
    location: "Pier",
    type: "fish",
    value: "10000",
    months:
      "[January, February, March, April, July, August, September, November, December]",
    time: "All day",
    shadow: "X Large",
  },
  {
    id: "129",
    name: "Blue Weevil Beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/99/NH-Icon-bellcricket.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "800",
    time: "All day",
  },
  {
    id: "10",
    name: "Bluegill",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/69/NH-Icon-bluegill.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "180",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "9 a.m. - 4 p.m.",
    shadow: "Small",
  },
  {
    id: "107",
    name: "Brown Cicada",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/a/ab/NH-Icon-browncicada.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "250",
    time: "8AM - 5PM",
  },
  {
    id: "21",
    name: "Butterfly Fish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/8e/NH-Icon-butterflyfish.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "1000",
    months: "[April, May, June, July, August, September]",
    time: "All day",
    shadow: "Small",
  },
  {
    id: "22",
    name: "Carp",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/2c/NH-Icon-carp.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "300",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "Large",
  },
  {
    id: "16",
    name: "Catfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/29/NH-Icon-catfish.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "800",
    months: "[May, June, July, August, September, October]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Large",
  },
  {
    id: "158",
    name: "Centipede",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/3/30/NH-Icon-centipede.png/revision/latest?cb=20200401005429",
    location: "Spawns when hitting a rock",
    type: "bug",
    value: "430",
    time: "5PM - 11PM",
  },
  {
    id: "17",
    name: "Char",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/15/NH-Icon-char.png/revision/latest?cb=20200401003129",
    location: "River/Pond",
    type: "fish",
    value: "3800",
    months: "[March, April, May, June,September, October, November]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Medium",
  },
  {
    id: "59",
    name: "Cherry Salmon",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/5f/NH-Icon-cherrysalmon.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "1000",
    months: "[March, April, May, June,September, October, November]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "112",
    name: "Cicada Shell",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/97/NH-Icon-cicadashell.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "10",
    time: "All day",
  },
  {
    id: "127",
    name: "Citrus Long-horned Beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/8f/NH-Icon-citruslonghornedbeetle.png/revision/latest?cb=20200401005428",
    location: "On Tree Stumps",
    type: "bug",
    value: "350",
    time: "All day",
  },
  {
    id: "38",
    name: "Clown Fish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/2f/NH-Icon-clownfish.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "650",
    months: "[April, May, June, July, August, September]",
    time: "All day",
    shadow: "Small",
  },
  {
    id: "25",
    name: "Coelacanth",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/3/31/NH-Icon-coelacanth.png/revision/latest?cb=20200401003129",
    location: "Sea (rainy days)",
    type: "fish",
    value: "15000",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "Largest",
  },
  {
    id: "86",
    name: "Common bluebottle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/5e/NH-Icon-commonbluebottle.png/revision/latest?cb=20200401005428",
    location: "Above Flowers",
    type: "bug",
    value: "300",
    time: "4AM - 7PM",
  },
  {
    id: "82",
    name: "Common butterfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/3/3a/NH-Icon-commonbutterfly.png/revision/latest?cb=20200401005428",
    location: "Above Flowers",
    type: "bug",
    value: "160",
    time: "4AM - 7PM",
  },

  {
    id: "63",
    name: "Crawfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/cd/NH-Icon-crawfish.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "200",
    months: "[April, May, June, July, August, September]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "101",
    name: "Cricket",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7a/NH-Icon-cricket.png/revision/latest?cb=20200401005428",
    location: "In Grass",
    type: "bug",
    value: "130",
    time: "5PM - 8AM",
  },
  {
    id: "53",
    name: "Crucian Carp",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/0/03/NH-Icon-cruciancarp.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "160",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "Small",
  },
  {
    id: "140",
    name: "Cyclommatus Stag",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/17/NH-Icon-cyclommatusstag.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "8000",
    time: "5PM - 8AM",
  },
  {
    id: "65",
    name: "Dab",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c6/NH-Icon-dab.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "300",
    months: "[January, February, March, April, October, November, December]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "49",
    name: "Dace",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/22/NH-Icon-dace.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "240",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Medium",
  },
  {
    id: "116",
    name: "Damselfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/16/NH-Icon-damselfly.png/revision/latest?cb=20200401005428",
    location: "Flying",
    type: "bug",
    value: "500",
    time: "All day",
  },
  {
    id: "114",
    name: "Darner dragonfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/70/NH-Icon-darnerdragonfly.png/revision/latest?cb=20200401005428",
    location: "Flying",
    type: "bug",
    value: "230",
    time: "8AM - 5PM",
  },
  {
    id: "120",
    name: "Diving beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c5/NH-Icon-divingbeetle.png/revision/latest?cb=20200401005428",
    location: "Water's Surface",
    type: "bug",
    value: "800",
    time: "8AM - 7PM",
  },
  {
    id: "31",
    name: "Dorado",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/d/df/NH-Icon-dorado.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "15000",
    months: "[June, July, August, September]",
    time: "4 a.m - 9 p.m.",
    shadow: "X Large",
  },
  {
    id: "134",
    name: "Drone Beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/99/NH-Icon-dronebeetle.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "200",
    time: "All day",
  },
  {
    id: "131",
    name: "Dung beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c0/NH-Icon-dungbeetle.png/revision/latest?cb=20200401005431",
    location: "On Ground",
    type: "bug",
    value: "3000",
    time: "All day",
  },
  {
    id: "132",
    name: "Earth-boring dung beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/0/0c/NH-Icon-earthboringdungbeetle.png/revision/latest?cb=20200401005428",
    location: "On Ground",
    type: "bug",
    value: "300",
    time: "All day",
  },
  {
    id: "90",
    name: "Emperor Butterfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/5e/NH-Icon-emperorbutterfly.png/revision/latest?cb=20200401005428",
    location: "Flying",
    type: "bug",
    value: "4,000",
    time: "5PM - 8AM",
  },
  {
    id: "111",
    name: "Evening Cicada",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/16/NH-Icon-eveningcicada.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "550",
    time: "4AM - 8AM,\r\n4PM - 7PM",
  },
  {
    id: "117",
    name: "Firefly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/a/ae/NH-Icon-firefly.png/revision/latest?cb=20200401005428",
    location: "Above Freshwater",
    type: "bug",
    value: "300",
    time: "7PM - 4PM",
  },
  {
    id: "155",
    name: "Flea",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/92/NH-Icon-flea.png/revision/latest?cb=20200401005428",
    location: "On Flea-Infested Villagers",
    type: "bug",
    value: "70",
    time: "All Day",
  },
  {
    id: "153",
    name: "Fly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/4/4f/NH-Icon-fly.png/revision/latest?cb=20200401005428",
    location: "On rotten food and garbage",
    type: "bug",
    value: "60",
    time: "All Day",
  },
  {
    id: "18",
    name: "Football Fish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/a/a5/NH-Icon-footballfish.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "2500",
    months: "[January, February, March, November, December]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Large",
  },
  {
    id: "62",
    name: "Freshwater Goby",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/ee/NH-Icon-freshwatergoby.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "400",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Small",
  },
  {
    id: "39",
    name: "Frog",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/6b/NH-Icon-frog.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "200",
    months: "[May, June, July, August]",
    time: "All day",
    shadow: "Small",
  },
  {
    id: "23",
    name: "Gar",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/9f/NH-Icon-gar.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "6000",
    months: "[July, August, September, October]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Largest",
  },
  {
    id: "109",
    name: "Giant Cicada",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/58/NH-Icon-giantcicada.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "500",
    time: "8AM - 5PM",
  },
  {
    id: "1",
    name: "Giant Snakehead",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/0/0c/NH-Icon-giantsnakehead.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "5500",
    months: "[June, July, August]",
    time: "9 a.m. - 4 p.m.",
    shadow: "X Large",
  },
  {
    id: "138",
    name: "Giant Stag",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/25/NH-Icon-giantstag.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "10000",
    time: "11PM - 8AM",
  },
  {
    id: "26",
    name: "Giant Trevally",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7b/NH-Icon-gianttrevally.png/revision/latest?cb=20200401003129",
    location: "Pier",
    type: "fish",
    value: "4500",
    months: "[May, June, July, August, September, October]",
    time: "All day",
    shadow: "Large",
  },
  {
    id: "121",
    name: "Giant water bug",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/55/NH-Icon-giantwaterbug.png/revision/latest?cb=20200401005428",
    location: "Water's Surface",
    type: "bug",
    value: "1600",
    time: "7PM - 8PM",
  },
  {
    id: "142",
    name: "Giraffe Stag",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7c/NH-Icon-giraffestag.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "12000",
    time: "5PM - 8AM",
  },
  {
    id: "141",
    name: "Golden Stag",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/82/NH-Icon-goldenstag.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "12000",
    time: "5PM - 8AM",
  },
  {
    id: "51",
    name: "Golden Trout",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/5c/NH-Icon-goldentrout.png/revision/latest?cb=20200401003129",
    location: "River (Clifftop)",
    type: "fish",
    value: "15000",
    months: "[March, April, May, June,September, October, November]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Large",
  },
  {
    id: "27",
    name: "Goldfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/ed/NH-Icon-goldfish.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "1300",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "Smallest",
  },
  {
    id: "135",
    name: "Goliath Beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/5b/NH-Icon-goliathbeetle.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "8000",
    time: "5PM - 8AM",
  },
  {
    id: "100",
    name: "Grasshopper",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/56/NH-Icon-grasshopper.png/revision/latest?cb=20200401005428",
    location: "In Grass",
    type: "bug",
    value: "160",
    time: "8AM - 5PM",
  },
  {
    id: "88",
    name: "Great Purple Emperor",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/27/NH-Icon-greatpurpleemperor.png/revision/latest?cb=20200401005428",
    location: "Above Flowers",
    type: "bug",
    value: "3000",
    time: "4AM - 7PM",
  },
  {
    id: "47",
    name: "Great White Shark",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/3/38/NH-Icon-greatwhiteshark.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "15000",
    months: "[June, July, August, September]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Largest (fin)",
  },
  {
    id: "50",
    name: "Guppy",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/63/NH-Icon-guppy.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "1300",
    months: "[April, May, June, July, August, September, October, November]",
    time: "betta",
    shadow: "Smallest",
  },
  {
    id: "48",
    name: "Hammerhead Shark",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/25/NH-Icon-hammerheadshark.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "8000",
    months: "[June, July, August, September]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Largest (fin)",
  },
  {
    id: "151",
    name: "Hermit crab",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7f/NH-Icon-hermitcrab.png/revision/latest?cb=20200401005430",
    location: "On beach, disguised as a shell",
    type: "bug",
    value: "1000",
    time: "7PM - 8AM",
  },
  {
    id: "105",
    name: "Honeybee",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/26/NH-Icon-honeybee.png/revision/latest?cb=20200401005428",
    location: "Above Flowers",
    type: "bug",
    value: "200",
    time: "8AM - 5PM",
  },
  {
    id: "144",
    name: "Horned Atlas",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/12/NH-Icon-hornedatlas.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "8000",
    time: "5PM - 8AM",
  },
  {
    id: "143",
    name: "Horned Dynastid",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/ef/NH-Icon-horneddynastid.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "1350",
    time: "5PM - 8AM",
  },
  {
    id: "145",
    name: "Horned Elephant",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/4/4f/NH-Icon-hornedelephant.png/revision/latest?cb=20200401005429",
    location: "On Trees",
    type: "bug",
    value: "8000",
    time: "5PM - 8AM",
  },
  {
    id: "146",
    name: "Horned Hercules",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c2/NH-Icon-hornedhercules.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "12000",
    time: "5PM - 8AM",
  },
  {
    id: "7",
    name: "Horse Mackerel",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/d/d5/NH-Icon-horsemackerel.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "150",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "Small",
  },
  {
    id: "126",
    name: "Jewel Beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/82/NH-Icon-jewelbeetle.png/revision/latest?cb=20200401005428",
    location: "On Trees, Tree Stumps",
    type: "bug",
    value: "2400",
    time: "All day",
  },
  {
    id: "34",
    name: "Killifish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c3/NH-Icon-killifish.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "300",
    months: "[April, May, June, July, August]",
    time: "All day",
    shadow: "Smallest",
  },
  {
    id: "8",
    name: "King Salmon",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/f/fd/NH-Icon-kingsalmon.png/revision/latest?cb=20200401003129",
    location: "River (mouth)",
    type: "fish",
    value: "1800",
    months: "[September]",
    time: "All day",
    shadow: "Largest",
  },
  {
    id: "35",
    name: "Koi",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/74/NH-Icon-koi.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "4000",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Large",
  },
  {
    id: "124",
    name: "Ladybug",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/18/NH-Icon-ladybug.png/revision/latest?cb=20200401005428",
    location: "On Flowers",
    type: "bug",
    value: "200",
    time: "8AM - 5PM",
  },
  {
    id: "76",
    name: "Loach",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/77/NH-Icon-loach.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "400",
    months: "[March, April, May]",
    time: "All day",
    shadow: "Small",
  },
  {
    id: "97",
    name: "Long locust",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/ef/NH-Icon-longlocust.png/revision/latest?cb=20200401005429",
    location: "In Grass",
    type: "bug",
    value: "200",
    time: "8AM - 4PM",
  },
  {
    id: "96",
    name: "Madagascan sunset moth",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7d/NH-Icon-madagascansunsetmoth.png/revision/latest?cb=20200401005429",
    location: "Flying",
    type: "bug",
    value: "2500",
    time: "8AM - 4PM",
  },
  {
    id: "32",
    name: "Mahi-mahi",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/82/NH-Icon-mahimahi.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "6000",
    months: "[May, June, July, August, September, October]",
    time: "All day",
    shadow: "Large",
  },
  {
    id: "123",
    name: "Man-Faced Stink Bug",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c7/NH-Icon-manfacedstinkbug.png/revision/latest?cb=20200401005429",
    location: "On Flowers",
    type: "bug",
    value: "1000",
    time: "7PM - 8AM",
  },
  {
    id: "103",
    name: "Mantis",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/0/00/NH-Icon-mantis.png/revision/latest?cb=20200401005429",
    location: "On Flowers",
    type: "bug",
    value: "430",
    time: "8AM - 5PM",
  },
  {
    id: "98",
    name: "Migratory Locust",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/e4/NH-Icon-migratorylocust.png/revision/latest?cb=20200401005429",
    location: "In Grass",
    type: "bug",
    value: "200",
    time: "8AM - 7PM",
  },
  {
    id: "24",
    name: "Mitten Crab",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/e3/NH-Icon-mittencrab.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "2000",
    months: "[ September, October, November]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Small",
  },
  {
    id: "137",
    name: "Miyama Stag",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/1b/NH-Icon-miyamastag.png/revision/latest?cb=20200401005429",
    location: "On Trees",
    type: "bug",
    value: "1000",
    time: "All day",
  },
  {
    id: "118",
    name: "Mole Cricket",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/0/00/NH-Icon-molecricket.png/revision/latest?cb=20200401005429",
    location: "Underground",
    type: "bug",
    value: "500",
    time: "All day",
  },
  {
    id: "89",
    name: "Monarch butterfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/99/NH-Icon-monarchbutterfly.png/revision/latest?cb=20200401005429",
    location: "Flying",
    type: "bug",
    value: "140",
    time: "4AM - 5PM",
  },
  {
    id: "33",
    name: "Moray Eel",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/e5/NH-Icon-morayeel.png/revision/latest?cb=20200401003130",
    location: "Sea",
    type: "fish",
    value: "2000",
    months: "[August, September, October, November]",
    time: "All day",
    shadow: "X Large",
  },
  {
    id: "154",
    name: "Mosquito",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c0/NH-Icon-mosquito.png/revision/latest?cb=20200401005429",
    location: "Flying",
    type: "bug",
    value: "130",
    time: "Night",
  },
  {
    id: "94",
    name: "Moth",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/12/NH-Icon-moth.png/revision/latest?cb=20200401005428",
    location: "Near Lights",
    type: "bug",
    value: "130",
    time: "7PM - 4AM",
  },
  {
    id: "64",
    name: "Napoleonfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/6f/NH-Icon-napoleonfish.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "10000",
    months: "[July, August]",
    time: "4 a.m. - 9 p.m.",
    shadow: "Largest",
  },
  {
    id: "37",
    name: "Neon Tetra",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/d/da/NH-Icon-neontetra.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "500",
    months: "[April, May, June, July, August, September, October, November]",
    time: "9 a.m. - 4 p.m.",
    shadow: "Smallest",
  },
  {
    id: "77",
    name: "Nibble Fish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/89/NH-Icon-nibblefish.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "1500",
    months: "[May, June, July, August, September]",
    time: "9 a.m. - 4 p.m.",
    shadow: "Small",
  },
  {
    id: "40",
    name: "Oarfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/3/33/NH-Icon-oarfish.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "9000",
    months: "[January, February, March, April, May, December]",
    time: "All day",
    shadow: "Largest",
  },
  {
    id: "36",
    name: "Ocean Sunfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/52/NH-Icon-oceansunfish.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "4000",
    months: "[July, August, September]",
    time: "4 a.m. - 9 p.m.",
    shadow: "(Fin)",
  },
  {
    id: "71",
    name: "Olive Flounder",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/9e/NH-Icon-oliveflounder.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "800",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "Large",
  },
  {
    id: "104",
    name: "Orchid mantis",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/9e/NH-Icon-orchidmantis.png/revision/latest?cb=20200401005428",
    location: "On Flowers",
    type: "bug",
    value: "2400",
    time: "8AM - 5PM",
  },
  {
    id: "60",
    name: "Pale Chub",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/2c/NH-Icon-palechub.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "200",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "9 a.m. - 4 p.m.",
    shadow: "Smallest",
  },
  {
    id: "87",
    name: "Paper Kite Butterfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/d/dd/NH-Icon-paperkitebutterfly.png/revision/latest?cb=20200401005429",
    location: "Flying",
    type: "bug",
    value: "1000",
    time: "8AM - 7PM",
  },
  {
    id: "85",
    name: "Peacock Butterfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/8f/NH-Icon-peacockbutterfly.png/revision/latest?cb=20200401005429",
    location: "Flying (Hybrid Flowers)",
    type: "bug",
    value: "2,500",
    time: "4AM - 7PM",
  },
  {
    id: "28",
    name: "Pike",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/d/dc/NH-Icon-pike.png/revision/latest?cb=20200401003130",
    location: "River",
    type: "fish",
    value: "1800",
    months: "[September, October, November, December]",
    time: "All day",
    shadow: "X Large",
  },
  {
    id: "157",
    name: "Pill bug",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c5/NH-Icon-pillbug.png/revision/latest?cb=20200401005428",
    location: "Spawns when hitting a rock",
    type: "bug",
    value: "250",
    time: "11PM - 4PM",
  },
  {
    id: "6",
    name: "Piranha",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/b/b9/NH-Icon-piranha.png/revision/latest?cb=20200401003130",
    location: "River",
    type: "fish",
    value: "2500",
    months: "[June, July, August, September]",
    time: "9 a.m. - 4 p.m., 9 p.m. - 4 a.m.",
    shadow: "Small",
  },
  {
    id: "70",
    name: "Pond Smelt",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/4/41/NH-Icon-pondsmelt.png/revision/latest?cb=20200401003130",
    location: "River",
    type: "fish",
    value: "500",
    months: "[January, February, December]",
    time: "All day",
    shadow: "Small",
  },
  {
    id: "119",
    name: "Pondskater",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/f/f4/NH-Icon-pondskater.png/revision/latest?cb=20200401005429",
    location: "Water's Surface",
    type: "bug",
    value: "130",
    time: "8AM - 7PM",
  },
  {
    id: "45",
    name: "Pop-eyed Goldfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c9/NH-Icon-popeyedgoldfish.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "1300",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "9 a.m. - 4 p.m.",
    shadow: "Smallest",
  },
  {
    id: "81",
    name: "Puffer Fish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/1f/NH-Icon-pufferfish.png/revision/latest?cb=20200401003130",
    location: "Sea",
    type: "fish",
    value: "250",
    months: "[July, August, September]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "93",
    name: "Queen Alexandra's Birdwing",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/b/b8/NH-Icon-queenalexandrasbirdwing.png/revision/latest?cb=20200401005429",
    location: "Flying",
    type: "bug",
    value: "4000",
    time: "8AM - 4PM",
  },
  {
    id: "139",
    name: "Rainbow stag",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/1c/NH-Icon-rainbowstag.png/revision/latest?cb=20200401005429",
    location: "On Trees",
    type: "bug",
    value: "6000",
    time: "7PM - 8AM",
  },
  {
    id: "9",
    name: "Rainbowfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/68/NH-Icon-rainbowfish.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "800",
    months: "[May, June, July, August, September, October]",
    time: "9 a.m. - 4 p.m.",
    shadow: "Small",
  },
  {
    id: "92",
    name: "Rajah brooke's birdwing",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/e2/NH-Icon-rajahbrookesbirdwing.png/revision/latest?cb=20200401005428",
    location: "flying",
    type: "bug",
    value: "2500",
    time: "8AM - 5PM",
  },
  {
    id: "58",
    name: "Ranchu Goldfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/f/f9/NH-Icon-ranchugoldfish.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "4500",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "9 a.m. - 4 p.m.",
    shadow: "Small",
  },
  {
    id: "54",
    name: "Ray",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/d/db/NH-Icon-ray.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "3000",
    months: "[April, May, June, July, August, September]",
    time: "4 a.m. - 9 p.m.",
    shadow: "X Large",
  },
  {
    id: "113",
    name: "Red dragonfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/eb/NH-Icon-reddragonfly.png/revision/latest?cb=20200401005428",
    location: "Flying",
    type: "bug",
    value: "180",
    time: "8AM - 7PM",
  },
  {
    id: "13",
    name: "Red Snapper",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/d/dd/NH-Icon-redsnapper.png/revision/latest?cb=20200401003130",
    location: "Sea",
    type: "fish",
    value: "3000",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "19",
    name: "Ribbon Eel",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/a/ac/NH-Icon-ribboneel.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "600",
    months: "[June, July, August, September, October]",
    time: "All day",
    shadow: "Narrow",
  },
  {
    id: "99",
    name: "Rice grasshopper",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/d/d3/NH-Icon-ricegrasshopper.png/revision/latest?cb=20200401005428",
    location: "In Grass",
    type: "bug",
    value: "1600",
    time: "8AM - 7PM",
  },
  {
    id: "108",
    name: "Robust Cicada",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/2f/NH-Icon-robustcicada.png/revision/latest?cb=20200401005429",
    location: "On Trees",
    type: "bug",
    value: "300",
    time: "8AM - 5PM",
  },
  {
    id: "128",
    name: "Rosalia Batesi Beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/e0/NH-Icon-rosaliabatesibeetle.png/revision/latest?cb=20200401005429",
    location: "On Tree Stumps",
    type: "bug",
    value: "3000",
    time: "All day",
  },
  {
    id: "43",
    name: "Saddled Bichir",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/a/a0/NH-Icon-saddledbichir.png/revision/latest?cb=20200401003130",
    location: "River",
    type: "fish",
    value: "4000",
    months: "[June, July, August, September]",
    time: "9 p.m. - 4 a.m.",
    shadow: "Large",
  },
  {
    id: "69",
    name: "Salmon",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/f/fb/NH-Icon-salmon.png/revision/latest?cb=20200401003129",
    location: "River (mouth)",
    type: "fish",
    value: "700",
    months: "[September]",
    time: "All day",
    shadow: "Small",
  },

  {
    id: "66",
    name: "Saw Shark",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/73/NH-Icon-sawshark.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "12000",
    months: "[June, July, August, September]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Largest (fin)",
  },
  {
    id: "136",
    name: "Saw Stag",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/4/48/NH-Icon-sawstag.png/revision/latest?cb=20200401005429",
    location: "On Trees",
    type: "bug",
    value: "2000",
    time: "All day",
  },
  {
    id: "133",
    name: "Scarab Beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/4/4c/NH-Icon-scarabbeetle.png/revision/latest?cb=20200401005429",
    location: "On Trees",
    type: "bug",
    value: "10000",
    time: "11PM - 8AM",
  },
  {
    id: "161",
    name: "Scorpion",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/3/34/NH-Icon-scorpion.png/revision/latest?cb=20200401005429",
    location: "On Ground",
    type: "bug",
    value: "8000",
    time: "7PM - 4AM",
  },
  {
    id: "73",
    name: "Sea Bass",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/22/NH-Icon-seabass.png/revision/latest?cb=20200401003130",
    location: "Sea",
    type: "fish",
    value: "400",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "X Large",
  },
  {
    id: "78",
    name: "Sea Butterfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/8f/NH-Icon-seabutterfly.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "1000",
    months: "[January, February, March, December]",
    time: "All day",
    shadow: "Smallest",
  },
  {
    id: "44",
    name: "Sea Horse",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/55/NH-Icon-seahorse.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "1100",
    months: "[April, May, June, July, August, September, October, November]",
    time: "All day",
    shadow: "Smallest",
  },

  {
    id: "156",
    name: "Snail",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/b/b1/NH-Icon-snail.png/revision/latest?cb=20200401005429",
    location: "On rocks",
    type: "bug",
    value: "250",
    time: "All Day",
  },
  {
    id: "41",
    name: "Snapping Turtle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/24/NH-Icon-snappingturtle.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "5000",
    months: "[April, May, June, July, August, September, October]",
    time: "9 p.m. - 4 a.m.",
    shadow: "X Large",
  },
  {
    id: "67",
    name: "Soft-shelled Turtle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/c3/NH-Icon-softshelledturtle.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "3750",
    months: "[August, September]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Large",
  },
  {
    id: "159",
    name: "Spider",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/2/26/NH-Icon-spider.png/revision/latest?cb=20200401005429",
    location: "Shaking Trees",
    type: "bug",
    value: "600",
    time: "7PM - 8AM",
  },
  {
    id: "52",
    name: "Squid",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/3/3b/NH-Icon-squid.png/revision/latest?cb=20200401003130",
    location: "Sea",
    type: "fish",
    value: "500",
    months:
      "[January, February, March, April, May, June, July, August, December]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "122",
    name: "Stinkbug",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/8/80/NH-Icon-stinkbug.png/revision/latest?cb=20200401005429",
    location: "On Flowers",
    type: "bug",
    value: "120",
    time: "All day",
  },
  {
    id: "46",
    name: "Stringfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/7/7b/NH-Icon-stringfish.png/revision/latest?cb=20200401003129",
    location: "River (Clifftop)",
    type: "fish",
    value: "15000",
    months: "[January, February, March, December]",
    time: "4 p.m. - 9 a.m.",
    shadow: "Largest",
  },
  {
    id: "72",
    name: "Sturgeon",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/98/NH-Icon-sturgeon.png/revision/latest?cb=20200401003129",
    location: "River (mouth)",
    type: "fish",
    value: "10000",
    months:
      "[January, February, March, April, May, June, July, August, September, October, November, December]",
    time: "All day",
    shadow: "Largest",
  },
  {
    id: "75",
    name: "Suckerfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/b/b9/NH-Icon-suckerfish.png/revision/latest?cb=20200401003131",
    location: "Sea",
    type: "fish",
    value: "1500",
    months: "[June, July, August, September]",
    time: "All day",
    shadow: "(Fin)",
  },
  {
    id: "79",
    name: "Surgeonfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/11/NH-Icon-surgeonfish.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "1000",
    months: " [April, May, June, July, August, September] ",
    time: "All day",
    shadow: "Small",
  },
  {
    id: "80",
    name: "Sweetfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/4/40/NH-Icon-sweetfish.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "900",
    months: "[July, August, September]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "14",
    name: "Tadpole",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/1c/NH-Icon-tadpole.png/revision/latest?cb=20200401003129",
    location: "Pond",
    type: "fish",
    value: "100",
    months: "[March, April, May, June,July]",
    time: "All day",
    shadow: "Smallest",
  },
  {
    id: "160",
    name: "Tarantula",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/0/0a/NH-Icon-tarantula.png/revision/latest?cb=20200401005429",
    location: "On Ground",
    type: "bug",
    value: "8000",
    time: "7PM - 4AM",
  },
  {
    id: "125",
    name: "Tiger beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/e3/NH-Icon-tigerbeetle.png/revision/latest?cb=20200401005428",
    location: "Flying",
    type: "bug",
    value: "1500",
    time: "All day",
  },
  {
    id: "84",
    name: "Tiger Butterfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/65/NH-Icon-tigerbutterfly.png/revision/latest?cb=20200401005429",
    location: "Above Flowers",
    type: "bug",
    value: "240",
    time: "4AM - 7PM",
  },
  {
    id: "42",
    name: "Tilapia",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/53/NH-Icon-tilapia.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "800",
    months: "[June, July, August, September, October]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "29",
    name: "Tuna",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/50/NH-Icon-tuna.png/revision/latest?cb=20200401003129",
    location: "Pier",
    type: "fish",
    value: "7000",
    months: "[January, February, March, April, November, December]",
    time: "All day",
    shadow: "X Large",
  },

  {
    id: "130",
    name: "Violin beetle",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/6a/NH-Icon-violinbeetle.png/revision/latest?cb=20200401005429",
    location: "On Trees",
    type: "bug",
    value: "450",
    time: "All day",
  },
  {
    id: "110",
    name: "Walker cicada",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/e/ec/NH-Icon-walkercicada.png/revision/latest?cb=20200401005429",
    location: "On Trees",
    type: "bug",
    value: "400",
    time: "8AM - 4PM",
  },
  {
    id: "148",
    name: "Walking Leaf",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/c/cb/NH-Icon-walkingleaf.png/revision/latest?cb=20200401005429",
    location: "On Ground (Beneath trees)",
    type: "bug",
    value: "600",
    time: "All day",
  },
  {
    id: "147",
    name: "Walking Stick",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/6/62/NH-Icon-walkingstick.png/revision/latest?cb=20200401005428",
    location: "On Trees",
    type: "bug",
    value: "600",
    time: "4AM - 8AM,\r\n5PM - 7PM",
  },
  {
    id: "106",
    name: "Wasp",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/9/9e/NH-Icon-wasp.png/revision/latest?cb=20200401005428",
    location: "Shaking Trees",
    type: "bug",
    value: "2500",
    time: "All day",
  },
  {
    id: "74",
    name: "Whale Shark",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/1c/NH-Icon-whaleshark.png/revision/latest?cb=20200401003129",
    location: "Sea",
    type: "fish",
    value: "13000",
    months: "[June, July, August, September]",
    time: "All day",
    shadow: "Largest (fin)",
  },
  {
    id: "152",
    name: "Wharf roach",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/5/5d/NH-Icon-wharfroach.png/revision/latest?cb=20200401005428",
    location: "On the rocky part of beaches",
    type: "bug",
    value: "200",
    time: "All Day",
  },
  {
    id: "83",
    name: "Yellow butterfly",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/f/fa/NH-Icon-yellowbutterfly.png/revision/latest?cb=20200401005428",
    location: "Flying",
    type: "bug",
    value: "160",
    time: "4AM - 7PM",
  },
  {
    id: "30",
    name: "Yellow Perch",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/1d/NH-Icon-yellowperch.png/revision/latest?cb=20200401003129",
    location: "River",
    type: "fish",
    value: "300",
    months: "[January, February, March, October, November, December]",
    time: "All day",
    shadow: "Medium",
  },
  {
    id: "12",
    name: "Zebra Turkeyfish",
    image:
      "https://vignette.wikia.nocookie.net/animalcrossing/images/1/1c/NH-Icon-zebraturkeyfish.png/revision/latest?cb=20200401003130",
    location: "Sea",
    type: "fish",
    value: "500",
    months: "[April, May, June, July, August, September, October, November]",
    time: "All day",
    shadow: "Medium",
  },
];
